import { BinanceFetch } from "@/shared/api/binanceFetch"

// 거래할 코인의 종류및 정보
export const FUTU_exchangeInfo = async (): Promise<BinanceAPI_FUTU_exchangeInfo_Res> => {
  const response = await BinanceFetch('/fapi/v1/exchangeInfo', {
    method: 'GET',
  })
  return response
}

export const FUTU_ticker_24hr = async (): Promise<BinanceAPI_FUTU_ticker_24hr_Res[]> => {
  const response = await BinanceFetch('/fapi/v1/ticker/24hr')
  return response
}


// 코인리스트 가져옴 ( 24시간 티커)
export const FUTU_ticker_24hr_symbol = async (symbol: string): Promise<BinanceAPI_FUTU_ticker_24hr_Res> => {
  const response = await BinanceFetch(`/fapi/v1/ticker/24hr?symbol=${symbol}`)
  return response
}


// 시장평군가 조회 ( 펀딩 비율) => coinid= "" 이면 전체 가져옴
export const FUTU_premiumIndex = async (coinid: string | ''): Promise<BinanceAPI_FUTU_premiumIndex_Res> => {
  let param = ''
  if (coinid) {
    param = '?symbol=' + coinid.toUpperCase()
  }

  const response = await BinanceFetch(`/fapi/v1/premiumIndex${param}`)
  return response
}